// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LwJnq","col":"styles_col__1M8Rd","actions":"styles_actions__31lX3","conflict":"styles_conflict__Q4ILh"};